import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined';
import { CbridgePalette } from '@cbridge-utils/mui-theme';
import { IFieldTooltipProps } from './FieldTooltip.interface';

export const FieldTooltip: FunctionComponent<IFieldTooltipProps> = (props) => {
  const { tooltip, iconColor } = props;

  if (!tooltip) {
    return null;
  }

  return (
    <Tooltip title={<Box sx={{
      whiteSpace: 'pre-wrap',
    }}>{tooltip}</Box>}>
      <HelpOutlineIcon
        sx={{ ml: 0.5, color: iconColor ? undefined : CbridgePalette.icon.secondary }}
        color={iconColor}
      />
    </Tooltip>
  );
};
